import React from 'react';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import TipsSection from './TipsSection';
import CTASection from './CTASection';
import Footer from '../../components/Footer';

const Mofu: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <AboutSection />
      <TipsSection />
      <CTASection />
      {/* Add more sections here as needed */}
    </div>
  );
};

export default Mofu;
